var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono_editar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 25,
    height: 25,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_63",
    "data-name": "Mask Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M0,3.347A2.53,2.53,0,0,0,.755,4.6q5.6,5.581,11.177,11.176a.787.787,0,0,0,.388.2q1.912.472,3.823.95c.032.008.062.022.093.033.215,0,.431,0,.646,0,.071,0,.087-.014.085-.085-.006-.2,0-.409,0-.613q-.309-1.227-.618-2.455-.189-.754-.374-1.51a.763.763,0,0,0-.2-.373Q11.5,7.66,7.223,3.386c-.9-.9-1.809-1.8-2.7-2.708A2.334,2.334,0,0,0,3.314,0H2.651A2.338,2.338,0,0,0,1.414.723c-.21.226-.429.446-.656.656A2.354,2.354,0,0,0,0,2.651ZM12.37,14.594c-.075-.013-.109-.068-.15-.109Q7.931,10.2,3.642,5.912c-.111-.111-.12-.174,0-.288C4.3,4.976,4.945,4.321,5.6,3.669c.166-.166.166-.166.329,0l8.212,8.212c.129.129.255.261.388.386.071.067.077.117,0,.19q-1.04,1.034-2.075,2.072a.933.933,0,0,1-.084.068M1.1,3a.817.817,0,0,1,.248-.62c.342-.345.682-.691,1.03-1.029A.863.863,0,0,1,3.6,1.345c.431.419.85.85,1.279,1.272.08.078.07.127,0,.2Q3.842,3.844,2.816,4.877c-.073.074-.123.085-.2.006-.422-.428-.85-.85-1.272-1.278A.8.8,0,0,1,1.1,3M15.656,15.662c-.72-.18-1.4-.352-2.077-.519-.125-.031-.093-.073-.029-.137q.726-.724,1.45-1.451c.084-.084.115-.075.143.041.117.488.241.973.362,1.46l.151.605",
    transform: "translate(4.015 4.016)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPencil);
export default __webpack_public_path__ + "static/media/icon_edit_pencil.02da31667b904be20a1ad42cd6f072c8.svg";
export { ForwardRef as ReactComponent };